import { SvgIconProps } from '@mui/material/SvgIcon';

import { SvgIcon } from './styled';

function CloudIcon(props: SvgIconProps) {
  return (
    <SvgIcon width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
      <g>
        <path
          d="M11.9999 6.66663H11.1599C10.9105 5.70062 10.3951 4.82395 9.67234 4.13622C8.94957 3.44849 8.04839 2.97729 7.07119 2.77614C6.094 2.575 5.07997 2.65199
          4.14435 2.99835C3.20872 3.34472 2.389 3.94658 1.77835 4.73555C1.16769 5.52451 0.790571 6.46894 0.689849 7.46153C0.589127 8.45411 0.768838 9.45505 1.20856
          10.3506C1.64828 11.2462 2.33039 12.0004 3.17737 12.5277C4.02434 13.0549 5.00223 13.334 5.99991 13.3333H11.9999C12.884 13.3333 13.7318 12.9821 14.3569
          12.357C14.9821 11.7319 15.3332 10.884 15.3332 9.99996C15.3332 9.1159 14.9821 8.26806 14.3569 7.64294C13.7318 7.01782 12.884 6.66663 11.9999 6.66663Z"
          stroke="currentColor"
          strokeWidth="1.33333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_598_13377">
          <rect width="16" height="16" fill="white" />
        </clipPath>
      </defs>
    </SvgIcon>
  );
}

export default CloudIcon;
